import Axios from "axios";
import {
    SET_INV_GATE_PASS_REPORTS_LIST, 
    UNSET_INV_GATE_PASS_REPORTS_LIST
} from "@/store/mutation-types";
import {
    getGatePassReports,
} from "@/store/api";

const state = {
    getGatePassReports: [],
};

const getters = {
    getGatePassReports(state) {
        return state.getGatePassReports;
    },
};

const mutations = {
    [SET_INV_GATE_PASS_REPORTS_LIST](state, data) {
        state.getGatePassReports = data;
    },
    [UNSET_INV_GATE_PASS_REPORTS_LIST](state) {
        state.getGatePassReports = [];
    },
};

const actions = {

    getGatePassReports({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getGatePassReports}`, { params: data })
                .then((response) => {
                    commit(SET_INV_GATE_PASS_REPORTS_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_INV_GATE_PASS_REPORTS_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};